/*
 * Import common js to use common function in this javascript file
 */
import { deleteConfirmationAlert } from "./common";

// Calander plugins
import { Calendar, diffDates } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';

var data = [];
var calendar = '';
if (window.$(".container-fluid").hasClass('dailyNotes')) {
    document.addEventListener('DOMContentLoaded', function() {
        var calendarEl = document.getElementById('dailyNotesCalendar');

        calendar = new Calendar(calendarEl, {
            plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
            events: window.$("form#dailyNotes").attr('action') + '?index=true',
            eventOrder: "id",
            droppable: false,
            selectOverlap: true,
            eventLimit: 2, // If you set a number it will hide the itens
            eventLimitText: "Something", // Default is `more` (or "more" in the lang you pick in the option)
            dayMaxEvents: 1,
            dayMaxEventRows: 2,
            firstDay: 1,
            timeZone: 'UTC',
            displayEventTime: false,
            themeSystem: "bootstrap",
            allDay:false,
            nextDayThreshold:'23:45:00',
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: ''
            },
            aspectRatio: 2,
            dayHeaderFormat: { weekday: 'long' },
            initialDate: new Date(),
            navLinks: true, // can click day/week names to navigate views
            editable: false,
            selectable: true,
            eventClick: function(info) {
                window.$(".fc-more-popover").fadeOut(400);
                window.$("#dailyModal").modal("show");
                window.$('#notes_error').empty();
                window.$('#dailyModal .richText-editor').html(info.event._def.extendedProps.titles);
                window.$('.dailyNotes .delete-icon').show();
                window.$('#dailyModal .updated_info').text(info.event._def.extendedProps.updated_info);
                window.$('#dailyModal .created_info').text(info.event._def.extendedProps.created_info);
                $("input[type='checkbox']").each(function() {
                    $(this).prop('checked', false);
                });
                let displaySource = info.event._def.extendedProps.source;
                if (displaySource == 'all') {
                    $("input[type='checkbox']").each(function() {
                        $(this).prop('checked', true);
                    });
                } else if (displaySource == 'widget') {
                    $("#widgetDailyNotes").prop('checked', true);
                } else if (displaySource == 'app') {
                    $("#tabletDailyNotes").prop('checked', true);
                }
                console.log(info.event._def.extendedProps)
                window.$("#notes_start_date").val(info.event._def.extendedProps.start_f1);
                window.$("#notes_end_date").val(info.event._def.extendedProps.end_f1);
                data = info;
            },
            dateClick: function(info) {
               // window.$('#dailyModal textarea').val('');
               window.$('#dailyModal .richText-editor').html("");
                window.$('#notes_error').empty();
                window.$("#dailyModal").modal("show");
                window.$('.dailyNotes .delete-icon').hide();
                window.$('#dailyModal .updated_info').text('');
                window.$('#dailyModal .created_info').text('');
                $("input[type='checkbox']").each(function() {
                    if ($(this).attr('id') == 'tabletDailyNotes') {
                        $(this).prop('checked', true);
                    } else {
                        $(this).prop('checked', false);
                    }
                });
                info['multiDate'] = "no";
                data = info;
                let d = (new Date(data.dateStr)).toISOString().slice(0, 10);
                let dformat = moment(d).format("DD.MM.YYYY");
                window.$("#notes_start_date").val(dformat);
                window.$("#notes_end_date").val(dformat);
                console.log(data);
            },
            select: function(info) {
               // window.$('#dailyModal textarea').val('');
                window.$('#dailyModal .richText-editor').html("");
                window.$('#notes_error').empty();
                window.$("#dailyModal").modal("show");
                window.$('.dailyNotes .delete-icon').hide();
                window.$('#dailyModal .updated_info').text('');
                window.$('#dailyModal .created_info').text('');
                $("input[type='checkbox']").each(function() {
                    if ($(this).attr('id') == 'tabletDailyNotes') {
                        $(this).prop('checked', true);
                    } else {
                        $(this).prop('checked', false);
                    }
                });
                info['multiDate'] = "yes";
                data = info;
                let s = (new Date(data.startStr)).toISOString().slice(0, 10);
                let ed = new Date(data.endStr);
                ed.setDate(ed.getDate() - 1);
                let e = (new Date(ed)).toISOString().slice(0, 10);
                data.endStr = e;
                let sformat = moment(s).format("DD.MM.YYYY");
                let eformat = moment(e).format("DD.MM.YYYY");
                window.$("#notes_start_date").val(sformat);
                window.$("#notes_end_date").val(eformat);
                
                console.log(data);
              },
            dayMaxEvents: false, // allow "more" link when too many events
        });

        calendar.render();
    });
}

/**
 * Save the daily note
 */
window.$('.dailyNotes .save-icon').on('click', function() {
    window.$('.dailyNotes').find('#notes').val(window.$('.dailyNotes').find('.richText-editor').html());
    var notes = window.$('.dailyNotes').find('#notes').val();

    var id = '';
    let startString = '';
    let endString = '';
    let multiDay = 'no';
    //  checked for update or add 
    if (typeof data.event != "undefined") {
        id = data.event._def.publicId;
        data.dateStr = '';
    } else {
        if(data.multiDate=="no" && typeof data.dateStr != "undefined"){
            data.dateStr = (new Date(data.dateStr)).toISOString().slice(0, 10)
        }else if(data.multiDate=="yes" && typeof data.dateStr == "undefined"){
            let startStr = data.startStr;
            let endStr   = data.endStr;
            let endDate = new Date(endStr);
            endDate.setDate(endDate.getDate());
            startString = (new Date(startStr)).toISOString().slice(0, 10);
            endString = endDate.toISOString().slice(0, 10);
            multiDay = 'yes';
        }
    }
    if(!window.$('#tabletDailyNotes').is(':checked') && !window.$('#widgetDailyNotes').is(':checked')){
        window.toastr.error("Please select where you want your Daily Note to be visible.", "Required");
        return false;
    }
    var querySting = (id != '') ? ('/' + id) : '';
    window.axios({
        method: (id != '') ? 'PUT' : 'POST',
        url: window.$("form#dailyNotes").attr('action') + querySting,
        data: window.$("form#dailyNotes").serialize() + '&date=' + data.dateStr + '&id=' + id + '&startdate='+startString+'&enddate='+endString+'&multiday='+multiDay,
    }).then(function(response) {
        window.toastr.success(response.data.message, response.statusText);
        window.$("#dailyModal").modal("hide");
        // Refresh calendar
        calendar.refetchEvents();
    }).catch(function(error) {
        if (error.response.status == 400) {
            window.$.each(error.response.data, function (key, value) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);
            });
            return false;
        }
        window.toastr.error(error.response.data.message, error.response.data.statusText);

    });

});


/**
 * Delete the daily note
 */
window.$('.delete_confirmation_modal').on('hidden.bs.modal', function() {
    //$("#dailyModal").attr("style", "z-index:999999 !important; display:block");
});
window.$('.dailyNotes .delete-icon').on('click', function() {
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    $("#dailyModal").removeAttr("style").attr("style", "display:block");
    promise.then(function(result) {
        // If confirmation true, do action for delete
        var id = data.event._def.publicId;
        window.axios({
            method: 'DELETE',
            url: window.$("form#dailyNotes").attr('action') + '/' + id,
        }).then(function(response) {
            window.toastr.success(response.data.message, response.statusText);
            window.$("#dailyModal").modal("hide");
            setTimeout(() => {
                window.$("#dailyModal").removeAttr('style').attr("style", "z-index:999999 !important; display:none !important");
            }, 800)

            // Refresh calendar
            calendar.refetchEvents();
        }).catch(function(error) {
            window.toastr.error(error.response.data.message, error.response.data.statusText);
        });
    }).catch(function(err) {
        console.log(err);
        return false;
    });
});

window.$("#dailyNotesAll").on('click', function() {
    if (window.$(this).is(':checked')) {
        $("#widgetDailyNotes").prop('checked', true);
        $("#tabletDailyNotes").prop('checked', true);
    } else {
        $("#widgetDailyNotes").prop('checked', false);
        $("#tabletDailyNotes").prop('checked', false);
    }
});

window.$(".dailyNotesSource").on('click', function() {
    if (window.$(this).is(':checked')) {
        let checkedboxLength = window.$(".dailyNotesSource:checked").length;
        if (checkedboxLength == 2) {
            window.$("#dailyNotesAll").prop('checked', true)
        } else {
            window.$("#dailyNotesAll").prop('checked', false)
        }
        let checkId = $(this).attr('id');
        window.$("#" + checkId).prop('checked', true);
    } else {
        window.$("#dailyNotesAll").prop('checked', false);
    }
});

// date and time picker
window.$("#notes_start_date").datetimepicker({
    timepicker: false,
    format: DATE_FORMAT,
    step: 15,
    dayOfWeekStart: 1,
    className:"dailyNotesPicker",
    closeOnDateSelect:true,
    onSelectDate:function(ct,$i){
        let date = moment(ct).format("DD.MM.YYYY");
        window.$("#notes_end_date").val(date);
        // window.$("#notes_end_date").datetimepicker({
        //     minDate: date
        // });
    },
    onShow: function (ct) {
        this.setOptions({
            
        })
    },
    onChangeYear: function (dateText, inst) {
        var date = moment(dateText).format("DD.MM.YYYY");
        window.$(inst).val(date);
    },
    onChangeMonth: function (dateText, inst) {
        var date = moment(dateText).format("DD.MM.YYYY");
        window.$(inst).val(date);
    }
});
window.$("#notes_end_date").datetimepicker({
    timepicker: false,
    format: DATE_FORMAT,
    step: 15,
    dayOfWeekStart: 1,
    className:"dailyNotesPicker",
    closeOnDateSelect:true,
    startDate:$("#notes_start_date").val(),
    //minDate: $("#notes_start_date").val(),
    onSelectDate:function(ct,$i){
        // window.$("#notes_start_date").datetimepicker({
        //     maxDate: ct
        // });
    },
    onShow: function (ct) {
        this.setOptions({
        })
    },
    onChangeYear: function (dateText, inst) {
        var date = moment(dateText).format("DD.MM.YYYY");
        window.$(inst).val(date);
    },
    onChangeMonth: function (dateText, inst) {
        var date = moment(dateText).format("DD.MM.YYYY");
        window.$(inst).val(date);
    }
});